export enum AccountingBasisEnum {
  CASH = 'CASH',
  ACCRUAL = 'ACCRUAL',
}

export enum AccountingFrequencyEnum {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
}

export enum DocumentNames {
  FeasibilityReport = 'FeasibilityReport',
  ForeignPartyLetter = 'ForeignPartyLetter',
  LiabilityDeclaration = 'LiabilityDeclaration',
  NewODI = 'NewODI',
  UndertakingForODI = 'UndertakingForODI',
  RemittanceForm = 'RemittanceForm',
  FEMADeclaration = 'FEMADeclaration',
  CRLLetter = 'CRLLetter',
  CACertificate = 'CACertificate',
}

export enum CommonDocumentNames {
  FormFC = 'FormFC', // generate
  BRInvestmentForm = 'BRInvestmentForm', // generate

  MemorandumOfAssociation = 'MemorandumOfAssociation', // available in app
  FE_Bylaws = 'FE_Bylaws', // available in app
  FE_CertificateOfIncorporation = 'FE_CertificateOfIncorporation', // available in app
  IE_CertificateOfIncorporation = 'IE_CertificateOfIncorporation', // available in app
  CorporatePAN = 'CorporatePAN', // available in app
  TAN = 'TAN', // available in app
  LLPDeed = 'LLPDeed', // available in app
  AnnualAuditPreviousYear = 'AnnualAuditPreviousYear', // available in app
}
